// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CMok","type":"styles_type__2xk23","choices":"styles_choices__32YHl"};